export const SET_LIST = 'statistics2/SET_LIST'
export const SET_TOTAL = 'statistics2/SET_TOTAL'
export const SET_CURRENT = 'statistics2/SET_CURRENT'
export const SET_INPUT_VALUE = 'statistics2/SET_INPUT_VALUE'